import { Component, Output, EventEmitter, Input } from "@angular/core";
import {
  FormControl,
  Validators,
  AbstractControl,
  FormGroup
} from "@angular/forms";
import { MemberResponse } from "@careapp/angular-sdk";
import { CUSTOMER_CARER_ROLE, CUSTOMER_FAMILY_ROLE } from "@careapp/core";

export interface AddTeamData {
  member?: MemberResponse;
  email?: string;
  role: string;
}

@Component({
  selector: "add-to-team-form",
  templateUrl: "./add-to-team-form.component.html",
  styleUrls: ["./add-to-team-form.component.scss"]
})
export class AddToTeamFormComponent {
  @Output()
  searchString = new EventEmitter<string>();

  @Output()
  addToTeam = new EventEmitter<AddTeamData>();

  @Output()
  cancel = new EventEmitter();

  @Input()
  searchMatches: Array<MemberResponse>;

  roleOptions = [CUSTOMER_CARER_ROLE, CUSTOMER_FAMILY_ROLE];

  onSubmit() {
    if (this.form.valid) {
      this.addToTeam.next({
        member: this.form.controls["search"].value.id
          ? this.form.controls["search"].value
          : undefined,
        email: !this.form.controls["search"].value.id
          ? this.form.controls["search"].value
          : undefined,
        role: this.form.controls["role"].value
      });
    }
  }

  form = new FormGroup({
    search: new FormControl(
      null,
      Validators.compose([
        Validators.required,
        (control: AbstractControl) =>
          !control.value || !control.value.id ? Validators.email(control) : null
      ])
    ),
    role: new FormControl(null, Validators.required)
  });

  update(value) {
    this.searchString.emit(value);
  }

  displayName(selection: MemberResponse) {
    return selection
      ? `${selection.firstName} ${selection.lastName} (${selection.email})`
      : "";
  }
}
